"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup_1 = require("@hookform/resolvers/yup");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const react_router_dom_1 = require("react-router-dom");
const option_api_1 = require("../../../../utils/api/option/option.api");
function UseEditOptionForm(option, close) {
    const validationSchema = yup.object().shape({
        value: yup.string().nullable().label("value"),
        image_value: yup.mixed().nullable().label("L'image"),
    });
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [image, setImage] = (0, react_1.useState)(null);
    const [valueField, setValueField] = (0, react_1.useState)("");
    const [address, setAddress] = (0, react_1.useState)("");
    const [phone, setPhone] = (0, react_1.useState)("");
    const [sendData, { isLoading, isSuccess, error, isError, data }] = (0, option_api_1.useEditOptionMutation)();
    (0, react_1.useEffect)(() => {
        if (option === null || option === void 0 ? void 0 : option.id) {
            const fields = [
                "value",
                "image_value",
                "id",
            ];
            for (let field of fields) {
                register(field);
                setValue(field, option[field]);
            }
            setValue("id", option === null || option === void 0 ? void 0 : option.id);
            setAddress(option === null || option === void 0 ? void 0 : option.value);
            setPhone(option === null || option === void 0 ? void 0 : option.value);
        }
    }, [option]);
    const handleChangeImage = (e) => {
        var _a;
        let file = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setValue("image_value", file);
        }
    };
    const handleChangeValue = (val) => {
        setValueField(val);
        setValue("value", val);
    };
    const handleChangeAddress = (val) => {
        setAddress(val === null || val === void 0 ? void 0 : val.rue);
        setValue("value", val === null || val === void 0 ? void 0 : val.rue);
    };
    const handleChangePhoneNumber = (val) => {
        setPhone(val);
        setValue("value", val);
    };
    (0, react_1.useEffect)(() => {
        if (option === null || option === void 0 ? void 0 : option.id) {
            const fields = [
                "value",
                "image_value",
                "id",
            ];
            for (let field of fields) {
                register(field);
                setValue(field, option[field]);
            }
            setValueField(option === null || option === void 0 ? void 0 : option.value);
        }
    }, [option]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            if (data === null || data === void 0 ? void 0 : data.success) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    iconColor: theme_1.Color.success,
                    confirmButtonColor: theme_1.Color.success,
                    title: data === null || data === void 0 ? void 0 : data.message,
                    showConfirmButton: false,
                    timer: 3000,
                }).then(() => {
                    !!close && close();
                });
            }
            else {
                sweetalert2_1.default.fire({
                    icon: "error",
                    title: data === null || data === void 0 ? void 0 : data.message,
                    showConfirmButton: false,
                    timer: 5000,
                });
            }
        }
        const err = error;
        if (isError) {
            console.log("error", err);
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message
                    : `Une erreur de statut ${err === null || err === void 0 ? void 0 : err.status} est survenue`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [error, isError, isSuccess]);
    (0, react_1.useEffect)(() => {
        // console.log("errors", errors, Object.values(errors));
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [clearErrors, errors]);
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        const fd = new FormData();
        data["_method"] = "PUT";
        for (let key of Object.keys(data)) {
            if (key === "image_value") {
                if (data[key]) {
                    fd.append(key, data[key]);
                }
            }
            else {
                fd.append(key, data[key]);
            }
        }
        console.log("data submit", data);
        yield sendData({ id: option === null || option === void 0 ? void 0 : option.id, data: fd });
    });
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        image,
        handleChangeImage,
        valueField,
        handleChangeValue,
        address,
        handleChangeAddress,
        phone,
        handleChangePhoneNumber
    };
}
exports.default = UseEditOptionForm;
